import React from 'react';
import { HelpCircle } from 'lucide-react';
import { useHelpMode } from '../contexts/HelpModeContext';

/**
 * HelpHint (Feb 2026)
 *
 * Renderiza un pequeño icono "(?)" con un tooltip nativo cuando el usuario
 * tiene activo el modo ayuda. Si el modo está desactivado o `text` está
 * vacío, no renderiza nada — mantiene la UI intacta.
 *
 * Uso:
 *   <F label="Precio Compra"><HelpHint text="Precio original al que se compró el activo" />
 *     <input ... />
 *   </F>
 *
 * Se usa el atributo nativo `title` para el tooltip para mantener 0 KB
 * extra de dependencias y funcionar bien con Tailwind puro.
 */
const HelpHint = ({ text, className = '', size = 14 }) => {
  const { enabled } = useHelpMode();
  if (!enabled || !text) return null;
  return (
    <span
      className={`inline-flex align-middle ml-1 text-slate-400 hover:text-blue-500 cursor-help transition-colors ${className}`}
      title={text}
      aria-label={text}
      role="tooltip"
      data-testid="help-hint"
    >
      <HelpCircle style={{ width: size, height: size }} />
    </span>
  );
};

export default HelpHint;
